export default __webpack_public_path__ + "static/media/edit-black.50e8dcbd.svg";